export const id_from_self = (self) => self.split("/")[2];



// WEBPACK FOOTER //
// ./mobile/shared/utils/self.js